module.exports = __webpack_public_path__ + "anno.png";